<script>
import Endpoints from '../../common/Endpoints';
import Common from '../../common/Common';
import Request from '../../common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        Common.loadFunctionsElements();

    },
    methods:{
        loadUserInfos: function(){
            if (this.$session.get('user')){
                let user = this.$session.get('user');
                this.user = user ? user : {};
                this.user.firstName = Common.camelize(this.user.firstName);
                this.companyName = this.user.companyUser.company.fantasyName;
                // if(this.user.companyUser.company && this.user.companyUser.company.typeService){
                //     this.isFleetDriver = this.user.companyUser.company.typeService.findIndex(x => x != 'FLEET_DRIVER') != -1 ? true : false;
                // }
            }
        },
        loggout: function(){
            this.$router.push({ path: '/Logout' });
            window.location.href = "?#/Logout";
        }
    }
}
</script>
